import { parseISO } from 'date-fns';
import dateFormat from 'date-fns/format';

export const DEFAULT_DATE_FORMAT = 'MM/dd/y';
export const DEFAULT_TIME_FORMAT = 'h:mm a';
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;

export const MONTH_YEAR_FORMAT = 'MMM. yyyy';

const isValidDate = (date: Date) => date instanceof Date && !isNaN(date.valueOf());

export const dateISOStringToFormat = (dateISOString: string, format = DEFAULT_DATE_TIME_FORMAT) => {
  // TODO: backend should return timezone/UTC indicator so we don't have to add it in
  const date = parseISO(dateISOString + 'Z');
  return isValidDate(date) ? dateFormat(date, format) : 'Invalid Date';
};

export const dateToFormat = (rawDate: Date, format = DEFAULT_DATE_TIME_FORMAT) =>
  dateFormat(rawDate, format);
